import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT, EnvType } from '../../APIConstants';
import { getApiBaseUrlSuffix, setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { AW_FRONTEND_AI_URL } from './Constants';

export const awFrontendAISettings: AGraphApiSettings = {};
export const awFrontendAIApi = axios.create();

awFrontendAIApi.interceptors.request.use((config) => {
  const { getAladdinApiKey, getConfigurationDirectoryFn, getEnvTypeFn } = awFrontendAISettings;
  const params = (config?.params ?? {}) as Record<string, unknown>;
  const configurationDirectory =
    params.configurationDirectory ?? (getConfigurationDirectoryFn ? getConfigurationDirectoryFn() : undefined);
  const envType = getEnvTypeFn ? getEnvTypeFn() : EnvType.DEFAULT;

  // TODO: Add AGraph support once aw-frontend-ai has an AGraph endpoint
  const baseURL = AW_FRONTEND_AI_URL + getApiBaseUrlSuffix(envType, '-', true);

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: API_TIMEOUT,
    params: {
      ...config.params,
      configurationDirectory,
    },
  };
  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), envType);
  return updatedConfig;
});
